var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: {
        title: "标准卡信息",
        width: 60,
        "class-name": "vertical-center-modal",
        "footer-hide": _vm.readOnly,
      },
      on: {
        "on-ok": _vm.onSave,
        "on-cancel": function ($event) {
          _vm.show = false
        },
        "on-visible-change": _vm.onShowChange,
      },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _vm.innerSpin
        ? _c("Spin", { attrs: { size: "large", fix: "" } })
        : _vm._e(),
      _c(
        "div",
        {
          staticStyle: {
            height: "500px",
            overflow: "scroll",
            "padding-left": "20px",
            "padding-right": "20px",
          },
        },
        [
          _c(
            "Form",
            {
              ref: "standardForm",
              staticClass: "small-form",
              attrs: {
                model: _vm.form,
                rules: _vm.ruleValidate,
                "label-position": "top",
              },
            },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "16" } },
                    [
                      _c(
                        "Row",
                        { attrs: { gutter: 16 } },
                        [
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "大类",
                                    prop: "standardMainCategoryUuid",
                                  },
                                },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: { filterable: "" },
                                      model: {
                                        value:
                                          _vm.form.standardMainCategoryUuid,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "standardMainCategoryUuid",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.standardMainCategoryUuid",
                                      },
                                    },
                                    _vm._l(
                                      _vm.mainCategoryOptions,
                                      function (item) {
                                        return _c(
                                          "Option",
                                          {
                                            key: item.mainCategoryUuid,
                                            attrs: {
                                              value: item.mainCategoryUuid,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(item.mainCategoryName)
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "小类",
                                    prop: "standardCardRelateSubCategoryUuid",
                                  },
                                },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: { filterable: "" },
                                      model: {
                                        value:
                                          _vm.form
                                            .standardCardRelateSubCategoryUuid,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "standardCardRelateSubCategoryUuid",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "\n                                        form.standardCardRelateSubCategoryUuid\n                                    ",
                                      },
                                    },
                                    _vm._l(
                                      _vm.subCategoryOptions,
                                      function (item) {
                                        return _c(
                                          "Option",
                                          {
                                            key: item.subCategoryUuid,
                                            attrs: {
                                              value: item.subCategoryUuid,
                                            },
                                          },
                                          [_vm._v(_vm._s(item.subCategoryName))]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "标准卡名称",
                                    prop: "standardCardName",
                                  },
                                },
                                [
                                  _c("Input", {
                                    model: {
                                      value: _vm.form.standardCardName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "standardCardName",
                                          $$v
                                        )
                                      },
                                      expression: "form.standardCardName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "描述" } },
                                [
                                  _c("Input", {
                                    model: {
                                      value: _vm.form.standardCardDesc,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "standardCardDesc",
                                          $$v
                                        )
                                      },
                                      expression: "form.standardCardDesc",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "销售期限" } },
                                [
                                  _c("integer-input", {
                                    attrs: { min: 0, max: 100 },
                                    model: {
                                      value: _vm.form.standardCardSalesPeriod,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "standardCardSalesPeriod",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.standardCardSalesPeriod",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "8" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            label: "图片",
                            prop: "standardCardImageFile",
                          },
                        },
                        [
                          _c("single-file-upload-with-name", {
                            model: {
                              value: _vm.form.standardCardImageFile,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "standardCardImageFile", $$v)
                              },
                              expression: "form.standardCardImageFile",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("Col", { attrs: { span: "4" } }),
                ],
                1
              ),
              _c("standard-card-form-items", {
                model: {
                  value: _vm.descJson,
                  callback: function ($$v) {
                    _vm.descJson = $$v
                  },
                  expression: "descJson",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "Button",
            {
              attrs: { type: "primary", size: "default" },
              on: { click: _vm.onSave },
            },
            [_vm._v("保存\n        ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }